module.exports = __webpack_public_path__ + "img/htkj_12.81175ee9.jpg";